export const urlBuilder = (url: string | undefined) => {
  return process.env.GATSBY_STRAPI_BASE_URL + (url || '')
}
